// https://vuex.vuejs.org/en/state.html

const state = {
  access_openai_config: false,
  loading: {},
  Cloader: {},
  emojiHistory: {},
  snackbar: {},
  AddToCard: {},
  AttachBox: {},
  systemExport: {},
  EmailDetectBox: {},
  productAdded: [],
  productPurchase: [],
  PurchaseProducts: {},
  link: {},
  isMobile: false,
  infocard: {},
  notifications: {},
  show: {
    videoChat: false,
    callOverlay: false,
    dash: true,
    users_drawer: false,
    search: false,
    overlay: false,
    chat: false,
    users_loader: true,
    look_loader: true,
    edit_user: false,
    conversation_load: false,
    similariy_rest: false,
    UserWritingDots: false,
  },
  app_drawer_links: [],
  chat_user: "",
  user_conversation_id: "",
  user_selected: "",
  msg_look: false,
  real_timeMessages: {
    localMsg: [],
    other: [],
  },
  online_users: [],
  notification: {
    joinChat: {},
    notif: 0,
    users: {},
  },
  prod_to_sent: {
    ids: [],
    item: [],
  },
  email_detect: [],
  display_grid: {
    liked: 4,
    disliked: 4,
    seen: 4,
    outher: 4,
    bookmarked: 4,
    recommended_IA: 4,
  },
  messanger_type_selected: undefined,
  messangerItems: [
    {
      icon: "context-all",
      name: "All",
      width: "20",
      height: "20",
      mode: "all",
    },
    {
      icon: "context-chat",
      name: "Chat",
      width: "20",
      height: "20",
      mode: "chat",
    },
    {
      icon: "context-style-profile",
      name: "Decision tree",
      width: "22",
      height: "22",
      mode: "style_profile",
    },
    {
      icon: "context-whatsApp",
      name: "WhatsApp",
      width: "20",
      height: "20",
      mode: "whatsapp_mode",
    },
    {
      icon: "context-info-orders",
      name: "infos mode",
      width: "20",
      height: "20",
      mode: "info_mode",
    },
    {
      icon: "context-your-mode",
      name: "reco_prod_mode",
      width: "20",
      height: "20",
      mode: "your_mode",
    },
    {
      icon: "context-rewards",
      name: "feedback_mode",
      width: "20",
      height: "20",
      mode: "rewards_mode",
    },
    {
      icon: "context-live-shop",
      name: "live_shopping_mode",
      width: "20",
      height: "20",
      mode: "live_shop_mode",
    },
    {
      icon: "context-product-s",
      name: "search_product_mode",
      width: "20",
      height: "20",
      mode: "product_s_mode",
    },
    {
      icon: "context-filtered-s",
      name: "search_filters_mode",
      width: "20",
      height: "20",
      mode: "filtered_s_mode",
    },
    {
      icon: "context-visual-s",
      name: "search_visual_mode",
      width: "20",
      height: "20",
      mode: "visual_s_mode",
    },
    {
      icon: "context-size",
      name: "reco_size_mode",
      width: "20",
      height: "20",
      mode: "size_mode",
    },
    {
      icon: "context-virtual-t-on",
      name: "virtual_tryon_mode",
      width: "20",
      height: "20",
      mode: "virtual_t_on_mode",
    },
  ],
};

export default state;
